(function(){
  var root=document.querySelector('[data-vs-quiz]');
  if(!root) return;

  var catalog={};
  try{
    var el=document.getElementById('vs-quiz-catalog');
    if(el) catalog=JSON.parse(el.textContent);
  }catch(e){ catalog={}; }

  var state={goal:null, mode:null};
  var step2=root.querySelector('[data-step="2"]');
  var step2Opts=root.querySelector('[data-step2-opts]');
  var step2Label=root.querySelector('[data-step2-label]');
  var progressFill=root.querySelector('[data-progress-fill]');
  var progressText=root.querySelector('[data-progress-text]');

  var SECOND={
    train:{
      label:'Full kit or lite?',
      options:[
        {mode:'bundle', label:'Training Stack', desc:'Whey + Pre + Creatine · Save $21'},
        {mode:'lite', label:'Train Lite', desc:'Whey + Creatine · Save $8 · no Pre'}
      ]
    },
    daily:{
      label:'Which morning stack?',
      options:[
        {mode:'bundle', label:'Daily Essentials', desc:'Multi + Omega + Probiotic · Save $8'}
      ]
    }
  };

  function needsSecond(){
    return !!(SECOND[state.goal]);
  }

  function updateProgress(current, total){
    if(!progressFill) return;
    var pct=Math.round((current/Math.max(total,1))*100);
    progressFill.style.width=pct+'%';
    if(progressText){
      if(current>=total && root.querySelector('[data-result]') && !root.querySelector('[data-result]').hidden){
        progressText.textContent='Done';
      } else {
        progressText.textContent='Step '+current+' of '+total;
      }
    }
  }

  function showStep(n){
    root.querySelectorAll('.vs-q').forEach(function(el){
      var on=String(el.getAttribute('data-step'))===String(n);
      el.hidden=!on;
      el.classList.toggle('is-on', on);
    });
    root.querySelector('[data-result]').hidden=true;
    var total=needsSecond()?2: (state.goal ? 1 : 2);
    updateProgress(n, state.goal && !needsSecond() ? 1 : 2);
  }

  function pickKey(){
    var g=state.goal, m=state.mode;
    if(g==='unsure') return 'daily-essentials-bundle';
    if(g==='night') return 'night-stack';
    if(g==='train'){
      if(m==='lite') return 'train-lite';
      return 'train-bundle';
    }
    if(g==='daily'){
      return 'daily-essentials-bundle';
    }
    return 'daily-essentials-bundle';
  }

  function finish(){
    root.querySelectorAll('.vs-q').forEach(function(el){ el.hidden=true; el.classList.remove('is-on'); });
    var r=root.querySelector('[data-result]');
    r.hidden=false;
    updateProgress(2, 2);

    var key=pickKey();
    var item=catalog[key]||{};
    var title=item.title||'Your start';
    var url=(item.url||'/collections/all');
    url += (url.indexOf('?')>=0?'&':'?')+'utm_campaign=start-quiz';

    r.querySelector('[data-r-title]').textContent=title;
    r.querySelector('[data-r-sub]').textContent=item.sub||'';
    r.querySelector('[data-r-copy]').textContent=item.why||'';
    r.querySelector('[data-r-price]').textContent=item.price||'';
    var cmp=r.querySelector('[data-r-compare]');
    if(item.compare){ cmp.hidden=false; cmp.textContent=item.compare; }
    else { cmp.hidden=true; cmp.textContent=''; }

    var saveEl=r.querySelector('[data-r-save]');
    if(item.save){
      saveEl.hidden=false;
      saveEl.textContent='Save '+item.save+' on the bundle';
    } else {
      saveEl.hidden=true;
      saveEl.textContent='';
    }

    var img=r.querySelector('[data-r-image]');
    if(item.image){ img.src=item.image; img.alt=title; img.hidden=false; }
    else { img.removeAttribute('src'); img.hidden=true; }

    var cta=r.querySelector('[data-r-cta]');
    cta.href=url;
    cta.textContent='Shop '+title;

    try{ r.scrollIntoView({behavior:'smooth', block:'start'}); }catch(e){}
  }

  function openSecond(){
    var cfg=SECOND[state.goal];
    if(!cfg){ finish(); return; }
    step2Label.textContent=cfg.label;
    step2Opts.innerHTML='';
    cfg.options.forEach(function(opt){
      var b=document.createElement('button');
      b.type='button';
      b.className='vs-choice';
      b.setAttribute('data-mode', opt.mode);
      b.innerHTML='<strong>'+opt.label+'</strong><span>'+opt.desc+'</span>';
      step2Opts.appendChild(b);
    });
    showStep(2);
  }

  function reset(){
    state={goal:null, mode:null};
    root.querySelectorAll('.vs-goal-card.is-on').forEach(function(b){ b.classList.remove('is-on'); });
    showStep(1);
    updateProgress(1, 2);
    try{ root.scrollIntoView({behavior:'smooth', block:'start'}); }catch(e){}
  }

  root.addEventListener('click', function(e){
    var back=e.target.closest('[data-back]');
    if(back){ e.preventDefault(); state.mode=null; showStep(1); return; }

    var retake=e.target.closest('[data-retake]');
    if(retake){ e.preventDefault(); reset(); return; }

    var goalBtn=e.target.closest('[data-goal]');
    if(goalBtn){
      state.goal=goalBtn.getAttribute('data-goal');
      state.mode=null;
      root.querySelectorAll('.vs-goal-card').forEach(function(b){ b.classList.toggle('is-on', b===goalBtn); });
      if(state.goal==='unsure' || state.goal==='night'){
        finish();
      } else {
        openSecond();
      }
      return;
    }

    var modeBtn=e.target.closest('[data-mode]');
    if(modeBtn){
      state.mode=modeBtn.getAttribute('data-mode');
      finish();
    }
  });

  updateProgress(1, 2);
  showStep(1);
})();
